var React = require('react');

function LinkedinLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.2 0H4a4 4 0 00-4 4v11.2a4 4 0 004 4h11.2a4 4 0 004-4V4a4 4 0 00-4-4zM6.4 15.2H4V6.4h2.4v8.8zM5.2 5.386c-.773 0-1.4-.632-1.4-1.412 0-.779.627-1.41 1.4-1.41.773 0 1.4.631 1.4 1.41 0 .78-.626 1.412-1.4 1.412zM16 15.2h-2.4v-4.483c0-2.695-3.2-2.49-3.2 0V15.2H8V6.4h2.4v1.412C11.517 5.743 16 5.59 16 9.792V15.2z","fill":"#52AFDD","fillRule":"nonzero"}));
}

LinkedinLogo.defaultProps = {"width":"20","height":"20"};

module.exports = LinkedinLogo;

LinkedinLogo.default = LinkedinLogo;
